import { Box, Collapse, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export type PaymentIconKind = 'card' | 'saved' | 'alma' | 'gift';

function Chip({ kind }: { kind: PaymentIconKind }) {
  switch (kind) {
    case 'alma':
      return <Box className="cv2-chip cv2-chip--dark">Alma</Box>;
    case 'saved':
      return <Box className="cv2-chip">••••</Box>;
    case 'gift':
      return <Box className="cv2-chip">◆</Box>;
    default:
      return <Box className="cv2-chip">CB</Box>;
  }
}

interface PaymentOptionProps {
  id: string;
  selected: boolean;
  disabled?: boolean;
  disabledReason?: string;
  icon: PaymentIconKind;
  title: ReactNode;
  subtitle?: ReactNode;
  /** Élément affiché à droite de la ligne (ex. logos des cartes acceptées). */
  trailing?: ReactNode;
  onSelect: (id: string) => void;
  /** Contenu déplié sous la ligne quand l'option est sélectionnée. */
  children?: ReactNode;
}

/**
 * Ligne « moyen de paiement » (maquette mobile.html, `.m-payment`) : radio
 * dessinée, pastille, titre + sous-titre, zone dépliable pour les champs
 * propres à l'option.
 */
export function PaymentOption({ id, selected, disabled, disabledReason, icon, title, subtitle, trailing, onSelect, children }: PaymentOptionProps) {
  return (
    <Box className={`cv2-option CheckoutV2PaymentOption${selected ? ' cv2-option--selected' : ''}${disabled ? ' cv2-option--disabled' : ''}`}>
      <button
        type="button"
        role="radio"
        aria-checked={selected}
        aria-disabled={disabled}
        className="cv2-option-row"
        onClick={() => !disabled && onSelect(id)}
        title={disabled ? disabledReason : undefined}
      >
        <span className="cv2-radio" />
        <Chip kind={icon} />
        <Box flex="1" minW={0}>
          <Text className="cv2-option-title">{title}</Text>
          {subtitle && <Text className="cv2-option-sub">{disabled && disabledReason ? disabledReason : subtitle}</Text>}
        </Box>
        {trailing}
      </button>
      {children && (
        <Collapse in={selected} unmountOnExit>
          <Box className="cv2-option-body">{children}</Box>
        </Collapse>
      )}
    </Box>
  );
}
